import * as React from 'react'
import { cn } from '../../lib/utils'

export interface PropertyDetailFieldProps extends React.HTMLAttributes<HTMLDivElement> {
	label: string
	value?: string | number | null
}

function PropertyDetailField({ label, value, className, ...props }: PropertyDetailFieldProps) {
	return (
		<div
			data-slot="property-detail-field"
			className={cn('flex items-center gap-5 text-sm', className)}
			{...props}
		>
			<span className="w-[195px] shrink-0 leading-5 text-(--color-muted-foreground)">{label}</span>
			<span className="leading-5 text-(--color-foreground) whitespace-nowrap">{value ?? '—'}</span>
		</div>
	)
}

PropertyDetailField.displayName = 'PropertyDetailField'

export interface PropertyDetailFieldListProps extends React.HTMLAttributes<HTMLDivElement> {}

function PropertyDetailFieldList({ className, ...props }: PropertyDetailFieldListProps) {
	return (
		<div
			data-slot="property-detail-field-list"
			className={cn('flex flex-col gap-3 text-sm', className)}
			{...props}
		/>
	)
}

PropertyDetailFieldList.displayName = 'PropertyDetailFieldList'

export { PropertyDetailField, PropertyDetailFieldList }
